const AccommodationGallerySection = () => {
  const handleReserveClick = () => {
    const reserveSection = document.getElementById('reserve');
    if (reserveSection) {
      reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleVillaTierraClick = () => {
    window.REACT_APP_NAVIGATE('/villa-tierra');
  };

  const handleVillaFuegoClick = () => {
    window.REACT_APP_NAVIGATE('/villa-fuego');
  };

  const handleVillaAireClick = () => {
    window.REACT_APP_NAVIGATE('/villa-aire');
  };

  const handleVillaAguaClick = () => {
    window.REACT_APP_NAVIGATE('/villa-agua');
  };

  const handleVillaEterClick = () => {
    window.REACT_APP_NAVIGATE('/villa-eter');
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6">
            Your Sanctuary Awaits
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Choose from our carefully selected villas, each offering a unique blend of comfort, 
            tranquility, and authentic Canarian charm. Every space is designed to support your 
            journey of healing and self-discovery.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Villa Aire */}
          <div 
            className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            onClick={handleVillaAireClick}
          >
            <div className="relative h-96 w-full">
              <img
                src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/040bd9a288abf18842636ea8845df332.jpeg"
                alt="Villa Aire - Elegant white building with colorful trim"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">Villa Aire</h3>
                <p className="text-sm text-white/90 mb-4">
                  Airy and spacious, perfect for those seeking lightness and clarity. 
                  Features open terraces and abundant natural light.
                </p>
                <div className="flex items-center text-sm">
                  <i className="ri-user-line mr-2"></i>
                  <span>Sleeps 2-4 guests</span>
                </div>
              </div>
            </div>
          </div>

          {/* Villa Agua */}
          <div 
            className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            onClick={handleVillaAguaClick}
          >
            <div className="relative h-96 w-full">
              <img
                src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/60de74325b464a5fa93913cc1e7d241a.jpeg"
                alt="Villa Agua - Beautiful white villa with arched doorways"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">Villa Agua</h3>
                <p className="text-sm text-white/90 mb-4">
                  Flow and fluidity define this serene space. Calming blue accents 
                  and water features create a peaceful atmosphere.
                </p>
                <div className="flex items-center text-sm">
                  <i className="ri-user-line mr-2"></i>
                  <span>Sleeps 2-3 guests</span>
                </div>
              </div>
            </div>
          </div>

          {/* Villa Eter */}
          <div 
            className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            onClick={handleVillaEterClick}
          >
            <div className="relative h-96 w-full">
              <img
                src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/68d901d342f8c2215c98868effd346c4.jpeg"
                alt="Villa Eter - Beautiful backyard with pool and colorful houses"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">Villa Eter</h3>
                <p className="text-sm text-white/90 mb-4">
                  Connect with the infinite. Private pool, meditation garden, 
                  and stunning sunset views for deep contemplation.
                </p>
                <div className="flex items-center text-sm">
                  <i className="ri-user-line mr-2"></i>
                  <span>Sleeps 4-6 guests</span>
                </div>
              </div>
            </div>
          </div>

          {/* Villa Fuego */}
          <div 
            className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            onClick={handleVillaFuegoClick}
          >
            <div className="relative h-96 w-full">
              <img
                src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/59b21acc2e58843c921781306305d80b.jpeg"
                alt="Villa Fuego - Warm villa with fire features and sunset colors"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">Villa Fuego</h3>
                <p className="text-sm text-white/90 mb-4">
                  Ignite your passion and energy. Warm terracotta tones, outdoor fire pit, 
                  and vibrant spaces for transformation and renewal.
                </p>
                <div className="flex items-center text-sm">
                  <i className="ri-user-line mr-2"></i>
                  <span>Sleeps 2-4 guests</span>
                </div>
              </div>
            </div>
          </div>

          {/* Villa Tierra */}
          <div 
            className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            onClick={handleVillaTierraClick}
          >
            <div className="relative h-96 w-full">
              <img
                src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/7e9917d46f66bb91ac6d12464f0a3d30.jpeg"
                alt="Villa Tierra - Earthy villa with natural stone and garden"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-serif font-bold mb-2">Villa Tierra</h3>
                <p className="text-sm text-white/90 mb-4">
                  Ground yourself in nature. Natural stone, wood elements, and a lush garden 
                  courtyard create a deeply rooted, peaceful sanctuary.
                </p>
                <div className="flex items-center text-sm">
                  <i className="ri-user-line mr-2"></i>
                  <span>Sleeps 3-5 guests</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-8">
            All villas include daily housekeeping, organic breakfast, and access to shared yoga spaces.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-sm text-gray-700">
            <div className="flex items-center">
              <i className="ri-wifi-line text-xl text-primary-500 mr-2"></i>
              <span>High-Speed WiFi</span>
            </div>
            <div className="flex items-center">
              <i className="ri-temp-cold-line text-xl text-primary-500 mr-2"></i>
              <span>Air Conditioning</span>
            </div>
            <div className="flex items-center">
              <i className="ri-restaurant-line text-xl text-primary-500 mr-2"></i>
              <span>Fully Equipped Kitchen</span>
            </div>
            <div className="flex items-center">
              <i className="ri-parking-box-line text-xl text-primary-500 mr-2"></i>
              <span>Free Parking</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccommodationGallerySection;